import { setContext } from 'apollo-link-context'
import { getToken } from '@polleverywhere/fetch/lib/csrf'

export const initialTokenLink = setContext(async (_, { headers }) => {
  // Get or fetch token
  const token = await getToken()
  // Return the headers as usual
  return {
    headers: {
      ...headers,
      'X-CSRF-Token': token
    }
  }
})
